import SidebarIcon from '../Icons/Sidebar'
import IconButton from './IconButton'

interface IButtonSidebar {
    overrides?: string
    opened?: boolean
    title?: string

    ['data-testid']?: string

    onClick?(): void
}

const ButtonSidebar = (props: IButtonSidebar) => {
    const {
        overrides,
        opened,
        title,

        onClick,
    } = props

    return (
        <IconButton
            data-testid={props['data-testid']}
            onClick={onClick}
            title={title}
            className={overrides}
        >
            <SidebarIcon opened={opened} />
        </IconButton>
    )
}

export default ButtonSidebar
